<template>
  <div id="app">
    <LoadingScreen />
    <router-view />
  </div>
</template>

<script>
import LoadingScreen from './components/LoadingScreen.vue'

export default {
  name: 'App',
  components: {
    LoadingScreen
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  overflow-x: hidden;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
